import { tieneSorbyIa } from './cuentaSorbyIa';

export const ANCHO_PANEL = 380;
export const ALTURA_ASA = 56;
export const ALTO_TOP_NAV = 64;
const UMBRAL_TECLADO = 150;

export const ESTADO = { ABIERTO: 'abierto', AMPLIADO: 'ampliado', PLEGADO: 'plegado' };
export const DISPOSICION = { PANEL: 'panel', HOJA: 'hoja' };
const CLAVE_ESTADO = 'sorby_ia_chat_estado';

// El chat acompaña en toda la web de las cuentas con Sorby IA, /sorby-ia incluida: ahí es el único chat.
export const mostrarChatAcoplado = (empresa) => tieneSorbyIa(empresa);

// `esEscritorio` es el ancho desde el que aparece el menú fijo (lg).
export const disposicionChat = (esEscritorio) => (esEscritorio ? DISPOSICION.PANEL : DISPOSICION.HOJA);

// Ampliar solo existe en la hoja; en el panel no cambia nada.
export const transicionChat = (estado, accion, disposicion = DISPOSICION.HOJA) => {
  switch (accion) {
    case 'plegar':
      return ESTADO.PLEGADO;
    case 'abrir':
      return disposicion === DISPOSICION.HOJA ? ESTADO.AMPLIADO : ESTADO.ABIERTO;
    case 'ampliar':
      return disposicion === DISPOSICION.HOJA && estado !== ESTADO.PLEGADO ? ESTADO.AMPLIADO : estado;
    case 'reducir':
      return estado === ESTADO.AMPLIADO ? ESTADO.ABIERTO : estado;
    default:
      return estado;
  }
};

// En celular, con el chat plegado, la página ofrece su propia barra para abrirlo.
export const mostrarBarraHablar = ({ visible, disposicion, estado }) =>
  visible === true && disposicion === DISPOSICION.HOJA && estado === ESTADO.PLEGADO;

// Solo se recuerda plegado o no; ampliado es un gesto de ese momento.
// Sin elección guardada, en celular arranca plegado (la barra lo abre) y en escritorio abierto.
export const estadoInicial = (guardado, esEscritorio = true) => {
  if (guardado === ESTADO.PLEGADO || guardado === ESTADO.ABIERTO) return guardado;
  return esEscritorio ? ESTADO.ABIERTO : ESTADO.PLEGADO;
};
export const estadoParaGuardar = (estado) => (estado === ESTADO.PLEGADO ? ESTADO.PLEGADO : ESTADO.ABIERTO);

export const leerEstadoGuardado = (esEscritorio = true) => {
  try {
    return estadoInicial(window.localStorage.getItem(CLAVE_ESTADO), esEscritorio);
  } catch {
    return estadoInicial(null, esEscritorio);
  }
};

export const guardarEstado = (estado) => {
  try {
    window.localStorage.setItem(CLAVE_ESTADO, estadoParaGuardar(estado));
  } catch {
    // Es una comodidad: sin almacenamiento el chat arranca abierto.
  }
};

// Lo que el contenido principal deja libre para que el chat no tape nada.
export const reservaDeEspacio = ({ visible, disposicion, estado }) => {
  if (!visible) return { derecha: 0, abajo: '0px' };
  const plegado = estado === ESTADO.PLEGADO;
  if (disposicion === DISPOSICION.PANEL) return { derecha: plegado ? 0 : ANCHO_PANEL, abajo: '0px' };
  return { derecha: 0, abajo: plegado ? `calc(${ALTURA_ASA}px + env(safe-area-inset-bottom))` : '50dvh' };
};

// Hasta dónde sube un botón flotante de la página: sobre el asa o la hoja; con la hoja a pantalla completa queda fuera de vista.
export const separacionFlotante = (chat) => {
  const { visible, disposicion, estado } = chat;
  return visible && disposicion === DISPOSICION.HOJA && estado === ESTADO.AMPLIADO ? '100dvh' : reservaDeEspacio(chat).abajo;
};

// `visual` es window.visualViewport: alto visible y desplazamiento. Sin él se asume que no hay teclado.
export const geometriaHoja = ({ estado, alturaVentana, visual }) => {
  const alturaVisible = Math.round(visual?.height ?? alturaVentana);
  const teclado = Math.max(0, Math.round(alturaVentana - alturaVisible - (visual?.offsetTop ?? 0)));
  const tecladoAbierto = teclado > UMBRAL_TECLADO;
  if (estado === ESTADO.PLEGADO) return { alto: ALTURA_ASA, abajo: 0, tecladoAbierto };
  // Con el teclado la hoja ocupa lo visible: media pantalla dejaría el campo de escribir sin lugar.
  const completa = estado === ESTADO.AMPLIADO || tecladoAbierto;
  return {
    alto: completa ? alturaVisible : Math.round(alturaVisible / 2),
    abajo: tecladoAbierto ? teclado : 0,
    tecladoAbierto,
  };
};
